export default "__VITE_ASSET__9e8cc684__"